import React from 'react';

// Stub for react-native-svg that converts to native SVG elements for the web

export const Svg = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  const {
    width,
    height,
    viewBox,
    children,
    style,
    ...rest
  } = props;

  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox={viewBox}
      style={style}
      {...rest}
    >
      {children}
    </svg>
  );
});

Svg.displayName = 'Svg';

export const Path = React.forwardRef<any, any>((props, ref) => {
  const { d, fill, stroke, strokeWidth, opacity, ...rest } = props;

  return (
    <path
      ref={ref}
      d={d}
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      opacity={opacity}
      {...rest}
    />
  );
});

Path.displayName = 'Path';

export const Circle = React.forwardRef<any, any>((props, ref) => {
  const { cx, cy, r, fill, stroke, strokeWidth, opacity, ...rest } = props;

  return (
    <circle
      ref={ref}
      cx={cx}
      cy={cy}
      r={r}
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      opacity={opacity}
      {...rest}
    />
  );
});

Circle.displayName = 'Circle';

export const Rect = React.forwardRef<any, any>((props, ref) => {
  const { x, y, width, height, fill, stroke, strokeWidth, opacity, rx, ry, ...rest } = props;

  return (
    <rect
      ref={ref}
      x={x}
      y={y}
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      opacity={opacity}
      rx={rx}
      ry={ry}
      {...rest}
    />
  );
});

Rect.displayName = 'Rect';

export const G = React.forwardRef<any, any>((props, ref) => {
  const { children, style, ...rest } = props;

  return (
    <g ref={ref} style={style} {...rest}>
      {children}
    </g>
  );
});

G.displayName = 'G';

export const Text = React.forwardRef<any, any>((props, ref) => {
  const { x, y, fill, stroke, fontSize, textAnchor, children, ...rest } = props;

  return (
    <text
      ref={ref}
      x={x}
      y={y}
      fill={fill}
      stroke={stroke}
      fontSize={fontSize}
      textAnchor={textAnchor}
      {...rest}
    >
      {children}
    </text>
  );
});

Text.displayName = 'Text';

export const Defs = React.forwardRef<any, any>((props, ref) => {
  const { children, ...rest } = props;

  return (
    <defs ref={ref} {...rest}>
      {children}
    </defs>
  );
});

Defs.displayName = 'Defs';

export const LinearGradient = React.forwardRef<any, any>((props, ref) => {
  const { id, x1, y1, x2, y2, children, ...rest } = props;

  return (
    <linearGradient
      ref={ref}
      id={id}
      x1={x1}
      y1={y1}
      x2={x2}
      y2={y2}
      {...rest}
    >
      {children}
    </linearGradient>
  );
});

LinearGradient.displayName = 'LinearGradient';

export const Stop = React.forwardRef<any, any>((props, ref) => {
  const { offset, stopColor, stopOpacity, ...rest } = props;

  return (
    <stop
      ref={ref}
      offset={offset}
      stopColor={stopColor}
      stopOpacity={stopOpacity}
      {...rest}
    />
  );
});

Stop.displayName = 'Stop';

export const ClipPath = React.forwardRef<any, any>((props, ref) => {
  const { id, children, ...rest } = props;

  return (
    <clipPath ref={ref} id={id} {...rest}>
      {children}
    </clipPath>
  );
});

ClipPath.displayName = 'ClipPath';

export const Mask = React.forwardRef<any, any>((props, ref) => {
  const { id, children, ...rest } = props;

  return (
    <mask ref={ref} id={id} {...rest}>
      {children}
    </mask>
  );
});

Mask.displayName = 'Mask';

export default Svg;
